import {AfterViewInit, Component, OnInit} from '@angular/core';
import { MessagesService } from '../../services/messages.service';
import {ContactService} from "../../services/contact.service";
import {Localiser} from "../../services/localiser";
import {UserService} from "../../services/user.service";
import {contacto} from "../../models/contacto";
import {Navigation} from "../../services/navigation.service";
import {ContactMessageService} from "../../services/contact-message.service";

@Component({
  selector: 'app-airfal',
  templateUrl: './airfal.component.html',
  styleUrls: ['./airfal.component.css']
})
export class AirfalComponent implements AfterViewInit {

  prioridad: string = this.localiser.get('contact.query');
  titulo: string;
  descripcion: string;
  contactButton = [false, false, false, false];
  contactos: contacto[] = [];

  actualizado: boolean = false;

  constructor(public contactService: ContactService, public localiser: Localiser,
              public user: UserService, private navigation: Navigation,
              public contactMessageService: ContactMessageService) { }

  ngAfterViewInit(): void {
    if (this.user.getIdContacto() == "0") {
      this.getContactosByIdUsuario();
    } else {
      this.getAllContactos();
    }
  }

  changeContactButton(index) {
    this.contactButton[index] = !this.contactButton[index];
  }

  isButtonEnabledOpenIssue(): boolean {
    const hasContactSelected = this.contactButton.some(button => button === true);
    const hasTitle = this.titulo?.trim().length > 0;
    const hasDescription = this.descripcion?.trim().length > 0;
    return hasContactSelected && hasTitle && hasDescription;
  }

  getContactsForMessage() {
    let valueList: string[] = [];
    this.contactButton.forEach((value, index) => {
      if (value) {
        valueList.push((index + 1) + '');
      }
    });
    return valueList;
  }

  getContactosByIdUsuario() {
    this.contactService.getByIdUsuario(this.user.getId()).subscribe(result => {
      this.contactos = <contacto[]> result;
    })
  }

  getAllContactos() {
    this.contactService.getAll().subscribe(result => {
      this.contactos = (<contacto[]> result).sort((a, b) => {
        return new Date(a.date).getTime() > new Date(b.date).getTime() ? -1 : 1;
      });
    })
  }

  newContacto() {
    let contacto: contacto = {
      idContacto: "ID",
      idUsuario: this.user.getId(),
      nombreUsuario: "",
      date: new Date(),
      situacion: this.localiser.get(this.contactService.getSituationUser()),
      prioridad: this.prioridad,
      contactos: this.getContactsForMessage().toString(),
      titulo: this.titulo,
      descripcion: this.descripcion,
      estado: "Abierto"
    }
    this.contactService.new(contacto).subscribe(result => {
      console.log(result)
      this.actualizado = true;
      let that = this;
      setTimeout(function () {
        that.actualizado = false;
        console.log("time")
      }, 2500);
      this.getContactosByIdUsuario();
    }, error => {
      console.log(error)
      this.actualizado = true;
      let that = this;
      setTimeout(function () {
        that.actualizado = false;
        console.log("time")
      }, 2500);
      this.getContactosByIdUsuario();
    });
  }

  getStringTime(date: Date) {
    let calendar = date.toString().split("T");
    let time = calendar[0].split("-");
    return time[2] + "/" + time[1] + "/" + time[0];
  }

  getAddressedTo(contactos: string) {
    let array = contactos.split(',');
    let addresses = "";
    for (let index in array) {
      if (index != "0") {
        addresses += ", ";
      }
      if (array[index] == "1") {
        addresses += this.localiser.get('contact.technicalManager');
      } else if (array[index] == "2") {
        addresses += this.localiser.get('contact.projectManager');
      } else if (array[index] == "3") {
        addresses += this.localiser.get('contact.commercial');
      } else if (array[index] == "4") {
        addresses += this.localiser.get('contact.administration');
      }
    }
    return addresses;
  }

  isInContact(contactos: string) {
    let array = contactos.split(',');
    return array.includes(this.user.getIdContacto());
  }

  toContactMessage(contacto: contacto) {
    this.contactMessageService.setContacto(contacto);
    this.navigation.toContactMessage();
  }

}
